import { render } from "./VariavelComponent.vue?vue&type=template&id=e3121ba0&scoped=true&ts=true"
import script from "./VariavelComponent.vue?vue&type=script&lang=ts"
export * from "./VariavelComponent.vue?vue&type=script&lang=ts"

import "./VariavelComponent.vue?vue&type=style&index=0&id=e3121ba0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3121ba0"]])

export default __exports__